export var ELEMENT_OPTIONS = {
  H1: "h1",
  H2: "h2",
  H3: "h3",
  H4: "h4",
  H5: "h5",
  H6: "h6",
  DIV: "div"
};
export var TYPE_OPTIONS = {
  DISPLAY: "display",
  DISPLAYSUBTITLE: "displaySubtitle",
  TITLE1: "title1",
  TITLE2: "title2",
  TITLE3: "title3",
  TITLE4: "title4",
  TITLE5: "title5"
};
export var TOKENS = {
  weightHeading: "weightHeading",
  sizeHeading: "sizeHeading",
  lineHeight: "lineHeight"
};